export const apiName: string = 'tipos-localidades';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidades-tipos/data.service.ts
 **/